var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProvinciaArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #25b4bd;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #3c3c3b;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #002f87;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -42,
    y: -40.7,
    width: 650,
    height: 271
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.9,111.1l49.8-31.5c11.1-6.9,22.2-1.5,22.2,10.8v36.7c0,4.2,2.9,7.1,7.4,7.1h9.6c31,0,57.9-22.4,57.9-60.6S131.7,9.4,95.2,9.4H18.3c-5.6.2-10.1,4.7-10.3,10.3v87.9c0,3.7,4.7,5.4,7.9,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,135.5v8.6c0,19.5,17,36,36.7,36h20.4c6.4,0,11.1-4.4,11.1-10.8v-71.7c0-3.3-2.5-6-5.8-6-1.3,0-2.5.4-3.6,1.1L12.2,127.4c-3.2,2-4.2,4.4-4.2,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,90.2c0,11-6.1,18.2-20.5,18.2h-9.5v17.1h-13.3v-53.7h22.8c14.2,0,20.5,7.2,20.5,18.5M236.5,90.2c0-5.2-2.3-7.5-7.9-7.5h-8.7v15.1h8.7c5.6,0,7.9-2.8,7.9-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284,80.7v13.2c-1.6-.3-3.2-.4-4.8-.4-6.4,0-9.1,3.8-9.5,10.9h0c0-.1,0,21.1,0,21.1h-12.8v-44.5h9.5l2.6,8.8c2.1-5.8,6.8-9.5,12.2-9.5.9,0,1.9,0,2.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.8,103.1c0-14.2,7.1-22.8,22-22.8s21.9,8.5,21.9,22.8-7.2,23.1-21.9,23.1-22-8.6-22-23.1M319.4,103c0-8.5-2.6-12.5-8.6-12.5s-8.8,4-8.8,12.5,2.7,12.9,8.8,12.9,8.6-4.2,8.6-12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.1,81l-14.6,44.4h-14.5l-14.6-44.4h12.9l7.8,26.8c.5,2,.8,4.1,1.1,6,.3-1.9.6-4,1.1-6l7.8-26.8h12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M383.6,69h12.8v8.2h-12.8v-8.2ZM383.6,81h12.8v44.4h-12.8v-44.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447,96v29.4h-12.8v-26.1c0-5.6-2.1-8.1-6.8-8.1s-8.1,3-8.5,9.7v24.6h-12.8v-44.4h9.5l2.3,7.8c2.5-5.8,7.5-8.5,14-8.5,9.7,0,15.1,5.2,15.1,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.2,103.3c0-14.1,7.8-22.9,22.6-22.9,5.6-.1,11.1,1.6,15.7,4.9l-4.1,10.5c-2.7-3-6.6-4.7-10.6-4.7-5.8,0-10.4,3.8-10.4,12.1s5,12.2,10.4,12.2c4,0,7.9-1.7,10.6-4.7l4.1,10.6c-4.6,3.3-10.1,5-15.7,4.9-14.5,0-22.6-8.8-22.6-22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M498.5,69h12.8v8.2h-12.8v-8.2ZM498.5,81h12.8v44.4h-12.8v-44.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M558,97.8v27.7h-9.5l-2.3-8.1c-2.2,5.5-6.9,8.9-14.2,8.9s-13.4-5.5-13.4-12.5c0-12.4,12.5-13.8,26.8-15.1h0c0-5.7-3.8-7.8-9.6-7.8-4.7.1-9.1,2-12.4,5.3l-5.1-9.5c5.5-4,12.1-6.1,18.8-6,14.5,0,20.8,6.2,20.8,17.3M545.4,108.6v-3.1c-8.2.9-13.9,1.8-13.9,6.8s1.4,4.5,5.1,4.5,8.5-2.3,8.8-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.1,171.7h-18.7l-2.8,8.1h-6.6l14.4-40.9h9l14.4,40.9h-7l-2.8-8.1ZM228.1,165.6l-6.2-18.2c-.5-1.2-.8-2.5-1.1-3.8-.4,1.6-.8,2.7-1.2,3.8l-6.1,18.2h14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.3,164.1h-8.1v15.7h-6.5v-40.9h17.2c9.3,0,13.9,4.3,13.9,12.9s-3.6,9.9-9.5,11.2c.4.4.7.8.9,1.1l10.3,15.7h-7.8l-10.3-15.7ZM252.2,158.4h9.6c5,0,8.2-1,8.2-6.6s-3.2-6.7-8.2-6.7h-9.6v13.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "313.2 144.9 300.3 144.9 300.3 179.8 293.8 179.8 293.8 144.9 280.8 144.9 280.8 138.9 313.2 138.9 313.2 144.9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvinciaArt);
export default __webpack_public_path__ + "static/media/Provincia_ART.e19b6b4faf25dca109a011c3f109a6a2.svg";
export { ForwardRef as ReactComponent };